<template>
    <a :href="props.post.link" target="_blank">
        <article>
            <v-img
                :alt="props.post.title"
                aspect-ratio="19/34"
                class="tw-h-auto tw-w-full"
                position="center"
                :src="props.post.image" />
            <h5 class="tw-mt-2 tw-text-center tw-font-title tw-text-xs tw-font-medium tw-text-black" v-html="props.post.title"></h5>
        </article>
    </a>
</template>

<script setup lang="ts">
    import type { WPTvPost } from '@/contentTypes';

    const props = defineProps<{
        post: WPTvPost;
    }>();
</script>

<style scoped></style>
